import { styled } from "styled-components";

import { knowledgeApiSlice } from "api/knowledgeApi.slice";
import { SectionTitleUnderlined, SeeAllButton, StyledGrid } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { PublicationItem } from "domains/publication/components/PublicationItem";

const StyledContainer = styled.div`
  margin-bottom: 2rem;
`;

const StyledItemContainer = styled.div`
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: ${({ theme }) => theme.borders.box};
  color: ${({ theme }) => theme.colors.fillPrimary};
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(31, 27, 82, 0.05);
`;

export const PublicationsResults = () => {
  const translate = useTranslate();

  const currentSearchQuery = useSelector((state) => state.search.currentSearchQuery);
  const currentSourceNames = useSelector((state) => state.search.sources);

  const { data: paginatedPublicationsSearchResults, isFetching } =
    knowledgeApiSlice.endpoints.searchPublications.useInfiniteQuery(
      { searchQuery: currentSearchQuery, sourceNames: currentSourceNames.map((source) => source.name) },
      { skip: currentSearchQuery.length === 0 },
    );

  const publicationsSearchResults = paginatedPublicationsSearchResults?.pages.flat() ?? [];

  if (currentSearchQuery.length === 0 || publicationsSearchResults.length === 0) return null;

  return (
    <>
      <StyledContainer>
        <SectionTitleUnderlined
          isLoading={isFetching}
          id="publications"
          rightElement={<SeeAllButton link="/search/publications" />}
        >
          {translate("app.discover.topic.tabs.knowledge.title")}
        </SectionTitleUnderlined>
        <StyledGrid numberOfItems={[1, 2, 3, 3, 4]}>
          {publicationsSearchResults.slice(0, 6).map((article) => (
            <StyledItemContainer key={article.id}>
              <PublicationItem
                title={article.title}
                description={article.summary ?? ""}
                imageUrl={article.images?.x_small}
                source={article.source}
                timestamp={article.time}
                link={`/search/publications/${article.id}`}
              />
            </StyledItemContainer>
          ))}
        </StyledGrid>
      </StyledContainer>
    </>
  );
};
